import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { PaymentForm } from './pages/PaymentForm';
import { TransactionStatus } from './pages/TransactionStatus';
import { NotFound } from './pages/NotFound';

export default function App() {
  return (
    <Routes>
      {/*
        Layout wrapper con header + logo. Todas las rutas hijas se renderizan
        adentro del <Outlet /> del Layout, así el header con el logo aparece
        en todas las vistas sin duplicar código.
      */}
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to="/404" replace />} />
        {/* Vista final del pago — DEBE estar antes que /:orderId para que matchee primero */}
        <Route
          path="/transaction/:processor/status/:orderId"
          element={<TransactionStatus />}
        />
        {/* Form de pago — el chatbot redirige acá con `?id=<encryptId>` */}
        <Route path="/:orderId" element={<PaymentForm />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
